import { render, staticRenderFns } from "./select-body.vue?vue&type=template&id=67c978cc&"
import script from "./select-body.vue?vue&type=script&lang=ts&"
export * from "./select-body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports